import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function () {
        return "api/import/index.php";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/fileuploadModel.js
// module id = 172
// module chunks = 0